export const SUCCESS_UPDATE_TOAST_MESSAGE = "¡Se guardó exitosamente el cambio en el espacio!";